<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="addNew"
      :count="count"
      :current="page">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>不合格单号:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" clearable
                    v-model.trim="query.unqualifiedApplyCode"></lk-input>
        </div>
        <div class="queryItem">
          <label class="ivu-form-item-required">不合格原因:</label>
          <lk-select class="item" clearable v-model="query.unqualifiedReason">
            <lk-option v-for="item in unqualifiedTypes" :key="item.id" :value="item.name">
              {{item.name}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label class="ivu-form-item-required">审批状态:</label>
          <lk-select class="item" clearable v-model="query.approveStatus">
            <lk-option v-for="(item, index) in approveStatusMap" :key="index" :value="item[0]">
              {{item[1]}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem storeSelect">
          <label class="ivu-form-item-required">供货商:</label>
          <SupplierListSelect multiple v-model="query.supplierIds"></SupplierListSelect>
        </div>
        <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>来源:</label>
          <lk-select class="item" v-model="query.purchaseType" clearable>
            <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>批号:</label>
          <lk-input class="item" v-model.trim="query.batchCode" :maxlength="50" clearable placeholder="请输入"></lk-input>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch(false, resetSelectedGoodsList)">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
         <div class="btnContainer">
<lk-button @click="addNew" icon='md-add' v-if="handlePermission('unqualifiedAdd')" type='primary' >新建不合格单</lk-button>
<lk-button @click="handlePrint" v-if="handlePermission('unqualifiedPrint')" type='primary' :disabled='selectedGoodsList.length === 0'>打印所选</lk-button>
   <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('unqualifiedExcel')"></DownloadButton>
         </div>
        <lk-table
          border
          :columns="columns"
          :data="tableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
    </QueryFrame>
    <LinkQR032 ref="LinkQR032"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import DownloadButton from '../../components/download/DownloadButton.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
// import supplier from '../../services/supplier';
// import permission from '../../mixins/permission'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import LinkQR032 from '../../components/print/LinkQR032';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

export default {
  name: 'unqualifiedRecord',
  mixins: [queryMixins],
  components: {
    QueryFrame,
    LinkQR032,
    SupplierListSelect,
    DownloadButton,
  },
  data() {
    return {
      query: {
        storeIdList: [],
        nameMix: null,
        unqualifiedApplyCode: null,
        unqualifiedReason: null,
        approveStatus: null,
        supplierIds: null,
        type: null, // 商品类型
        purchaseType: null, // 来源
        batchCode: null, // 批号
      },
      selectedGoodsList: [],
      breakageStatusMap: new Map([
        [1, '未申请'],
        [2, '已申请'],
      ]),
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      approveStatusMap: new Map([
        [1, '审批中'],
        [2, '审批通过'],
        [3, '审批驳回'],
      ]),
      unqualifiedTypes: [{
        id: 1,
        name: '药品过期',
      }, {
        id: 2,
        name: '药监抽检',
      }, {
        id: 3,
        name: '药品损坏',
      }, {
        id: 4,
        name: '饮片清斗',
      }, {
        id: 5,
        name: '效期滞销'
      }],
      columns: [
        {
          title: '选择',
          key: 'unqualifiedRecordId',
          type: 'selection',
          width: 80,
        },
        {
          title: '不合格单号',
          key: 'unqualifiedRecordUnqualifiedApplyCode',
          minWidth: 180,
        },
        {
          title: '商品编码',
          key: 'unqualifiedRecordDrugSerialCode',
          minWidth: 110,
        },
        {
          title: '商品名称',
          key: 'unqualifiedRecordGoodsName',
          minWidth: 140,
        },
        {
          title: '通用名称',
          key: 'unqualifiedRecordApprovedDrugNames',
          minWidth: 160,
        },
        {
          title: '助记码',
          key: 'unqualifiedRecordMnemonicCode',
          minWidth: 110,
        },
        {
          title: '规格',
          key: 'unqualifiedRecordSpecifications',
          minWidth: 110,
        },
        {
          title: '生产厂家',
          key: 'unqualifiedRecordManufacturer',
          minWidth: 110,
        },
        {
          title: '上市许可持有人',
          minWidth: 120,
          tooltip: true,
          key: 'mah',
        },
        {
          title: '供货商',
          key: 'unqualifiedRecordSupplierName',
          minWidth: 110,
        },
        {
          title: '商品类型',
          key: 'unqualifiedRecordGoodsTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '来源',
          key: 'unqualifiedRecordPurchaseTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品状态',
          key: 'unqualifiedRecordGoodsStoreStatusStr',
          minWidth: 110,
        },
        {
          title: '剂型',
          key: 'unqualifiedRecordDosageForm',
          minWidth: 110,
        },
        {
          title: '单位',
          key: 'unqualifiedRecordDrugMiniPackageUnit',
          minWidth: 110,
        },
        {
          title: '仓库',
          key: 'unqualifiedRecordWarehouseName',
          minWidth: 110,
        },
        {
          title: '货位',
          key: 'unqualifiedRecordLocationCode',
          minWidth: 110,
        },
        {
          title: '批次',
          key: 'unqualifiedRecordGoodsBatchSeq',
          minWidth: 110,
        },
        {
          title: '批号',
          key: 'unqualifiedRecordGoodsBatchNumber',
          minWidth: 110,
        },
        {
          title: '不合格数量',
          key: 'unqualifiedRecordUnqualifiedCount',
          minWidth: 110,
        },
        {
          title: '不合格原因',
          key: 'unqualifiedRecordApplyReason',
          minWidth: 110,
        },
        {
          title: '创建时间',
          key: 'unqualifiedRecordCreateTime',
          minWidth: 110,
        },
        {
          title: '创建人',
          key: 'unqualifiedRecordCreateUserName',
          minWidth: 110,
        },
        {
          title: '审批状态',
          key: 'unqualifiedRecordApproveStatusStr',
          minWidth: 110,
        },
        {
          title: '报损状态',
          key: 'unqualifiedRecordBreakageStatusStr',
          minWidth: 110,
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    selectedTempGoodsIds() {
      const result = [];
      this.selectedGoodsList.forEach((item) => {
        result.push(item.unqualifiedRecordId);
      });
      return result;
    },
  },
  methods: {
    handlePrint() {
      this.$refs.LinkQR032.handlePrint(this.selectedTempGoodsIds);
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      inventory.unqualifiedRecordList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          this.tableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            console.log(result)
            result.unqualifiedRecordCreateTime = utils.exchangeTime(result.unqualifiedRecordCreateTime);
            result.unqualifiedRecordGoodsStoreStatusStr = this.statusMap.get(result.unqualifiedRecordGoodsStoreStatus);
            result.unqualifiedRecordApproveStatusStr = this.approveStatusMap.get(result.unqualifiedRecordApproveStatus);
            // if(result.unqualifiedRecordApproveStatusStr==='审批通过'){
            //      result.unqualifiedRecordBreakageStatusStr = this.breakageStatusMap.get(result.unqualifiedRecordBreakageStatus);
            // }else{
            //      result.unqualifiedRecordBreakageStatusStr = ''
            // }
            result.unqualifiedRecordBreakageStatusStr=result.unqualifiedRecordApproveStatusStr==='审批通过'?this.breakageStatusMap.get(result.unqualifiedRecordBreakageStatus):'';
            result._checked = this.selectedTempGoodsIds.includes(result.unqualifiedRecordId);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleTempSelect(selection, row) {
      if (!this.selectedTempGoodsIds.includes(row.unqualifiedRecordId)) {
        this.selectedGoodsList.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.selectedGoodsList.forEach((item, index) => {
        if (item.unqualifiedRecordId === row.unqualifiedRecordId) {
          this.selectedGoodsList.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(item.unqualifiedRecordId)) {
          this.selectedGoodsList.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      this.tableData.forEach((good) => {
        for (let i = 0, len = this.selectedGoodsList.length; i < len; i++) {
          if (this.selectedGoodsList[i].unqualifiedRecordId === good.unqualifiedRecordId) {
            this.selectedGoodsList.splice(i, 1);
            break;
          }
        }
      });
    },
    addBreakage() {
      let errorMsg = '';
      const ids = [];
      for (let i = 0, len = this.selectedGoodsList.length; i < len; i++) {
        const item = this.selectedGoodsList[i];
        if (item.unqualifiedRecordApproveStatus !== 2) {
          errorMsg = '只可以添加审批通过的不合格记录';
          break;
        }
        ids.push(item.unqualifiedRecordId);
      }
      if (errorMsg) {
        this.$Message.error(errorMsg);
        return;
      }
      this.$router.push({
        name: 'unqualifiedBreakageAdd',
        params: {
          ids: ids.join(','),
        },
      });
    },
    addNew() {
      this.$router.push({ name: 'unqualifiedAdd' });
    },
    handleReset() {
      this.query = {};
    },
    resetSelectedGoodsList() {
      this.selectedGoodsList = [];
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      // params.goodsType = 3;
      // if (params.duration.length) {
      //   params.startTime = params.duration[0];
      //   params.endTime = params.duration[1];
      // }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      inventory.ExportUnqualified(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.handleSearch(true, this.resetSelectedGoodsList);

    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
.btnContainer{
  margin-bottom: 12px;
  margin-top:2px;
  >*{
    margin-right: 8px
  }

}
</style>
